export default "__VITE_ASSET__Jz0QuzcX__"